import { render, staticRenderFns } from "./ExchangeSource.vue?vue&type=template&id=a6ae56e0"
import script from "./ExchangeSource.vue?vue&type=script&lang=js"
export * from "./ExchangeSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports